module.exports = __webpack_public_path__ + "img/shopper.b5e376e5.svg";